/**
 * Сколько баллов даёт действие — числа для чипов «+N · сфера». ЕДИНСТВЕННОЕ место
 * с этими числами на сайте: диета, курсы, СУП, лига и меню берут их отсюда.
 *
 * Два вида чисел, и чип рисует их по-разному:
 *  - PAID — сервер платит это СЕГОДНЯ (POINTS_BRIEF §2, ✓): сплошной чип;
 *  - PROPOSAL — таблица баллов владельца (v8.2 от 29.09, артефакт «Таблица баллов
 *    MY REVIVE»), которая лежит в site_server (и в воркере) за выключенными флагами
 *    (services_fastapi/points_rules.py). Пока флаг не включён, такой чип стоит только
 *    пунктиром с «предложение» и рядом — сколько платится сейчас.
 *
 * Таблица сейчас — v8.2, утверждённая владельцем 29.09.2026 (артефакт «Таблица баллов»,
 * M6D1Y3Cch8jn4ZworJPQ4H). Логика (слова владельца): вклад (покупки) — самая важная сфера,
 * приглашённые — самая сложная и не менее важная, потом общественное, тренировки и обучение —
 * наименее важные; деньги дают очень значительные баллы; очень активный заполняет сферу
 * примерно за год, обычный — за 2–3 года. Всё, что продаётся, — около 80 % вклада. Аюрведическое
 * (диагностики, консультации, товары) — в 10–100 раз меньше и вне годового порога. Альтернативы
 * (пакет вместо своего содержимого, издания пособия, «для мужчин» или «для женщин», выдача
 * админом вместо покупки, пакеты токенов разного размера) считаются ОДИН раз, а не складываются.
 * Покупка друга — 1 250 за каждый $1 его заказа, без потолка. Возврат снимает баллы, подарок
 * считается дарителю. Поменялась таблица — меняются числа здесь и на сервере.
 *
 * С 29.09 таблица v8.2 для администраторов уже НАСТОЯЩАЯ (POINTS_V82_LIVE ниже): чипы правил
 * PROPOSAL рисуются сплошными, без «предложение» и «сейчас …».
 */

/**
 * Таблица v8.2 ДЕЙСТВУЕТ для администраторов. Владелец, 29.09: «включи для всех, но пока не
 * показывай никому кроме админов» — сервер и воркер начисляют v8.2 каждому «в тени», а числа
 * v8.2 отдают только администраторам. Чипы «+N · сфера» на сайте и так видят только
 * администраторы (usePointsPreview / useAdminUI), поэтому для них это настоящие баллы: чип
 * сплошной, без «предложение», без «сейчас +N» и без «включится после согласования».
 * Остальные посетители чипов не видят вовсе — у них ничего не меняется.
 *
 * Деньги этот переключатель НЕ включает: −20 % на следующую часть (COURSE_V5_FLAGS.nextPartDiscount),
 * «Обе сразу» у диагностик (DIAGNOSTICS_BUNDLE_ENABLED), подарки и токены — у них свои флаги.
 * false — вернуть пунктир «предложение · сейчас …» (например, если тень выключат).
 */
export const POINTS_V82_LIVE: boolean = true;

/** Вид чипа правила из таблицы v8.2: сплошной («paid»), пока таблица действует для администраторов. */
export const V82_CHIP_VARIANT: "paid" | "proposal" = POINTS_V82_LIVE ? "paid" : "proposal";

/** Друг купил по партнёрской ссылке: сегодня +2 000 приглашённых (воркер, REFERRAL_PURCHASE_POINTS). PAID. */
export const REFERRAL_PURCHASE_POINTS = 2000;

/**
 * Какой ставкой считается покупка. Обычная — курсы, пособие, приложение, токены, пакеты.
 * Аюрведическое — в 10–100 раз меньше: диагностика и консультация — 10 за $1, товар (спрей,
 * семена на ухо) — 100 за $1; оно не входит в годовой порог $300 и само его не расходует
 * (points_rules.PURCHASE_REDUCED_POINTS_PER_USD).
 */
export type PurchaseKind = "regular" | "diagnostic" | "consultation" | "ayurvedic";

/** Вид продукта из каталога (shared/config/products.ts) → ставка баллов. */
export const purchaseKindOf = (productKind: string | undefined | null): PurchaseKind =>
    productKind === "diagnostic" || productKind === "consultation"
        ? productKind
        : productKind === "goods"
          ? "ayurvedic"
          : "regular";

/** Аюрведическое округляется до 50, а не до 500: иначе 3 750 за диагностику друга стали бы 4 000. */
export const REDUCED_ROUND_TO = 50;

/**
 * Друг купил по ссылке — таблица v8.2: 1 250 приглашённых за каждый $1 цены его заказа без
 * скидки (пакет — по цене пакета), БЕЗ потолка на покупку; заказ округляется до 500 (половина —
 * вверх); первые 10 заказов друзей в год — полностью, дальше половина. Диагностика и
 * консультация друга — 12,5 за $1 ($300 → 3 750), аюрведический товар — 125 за $1; они
 * округляются до 50 (points_rules.friend_purchase_points). PROPOSAL; сегодня воркер платит
 * +2 000 за любую покупку по ссылке.
 * Часть курса $14.90 → 18 500 (после десятой — 9 500); год приложения $49.99 → 62 500;
 * пакет «Системный подход» $104.90 → 131 000.
 */
export const REFERRAL_PURCHASE_POINTS_PER_USD = 1250;
export const REFERRAL_REDUCED_POINTS_PER_USD: Record<Exclude<PurchaseKind, "regular">, number> = {
    diagnostic: 12.5,
    consultation: 12.5,
    ayurvedic: 125,
};
export const REFERRAL_PURCHASE_ROUND_TO = 500;
export const REFERRAL_PURCHASE_FULL_PER_YEAR = 10;
export const REFERRAL_PURCHASE_RATE_AFTER = 0.5;
export const friendPurchasePoints = (
    listPriceCents: number,
    doneThisYear = 0,
    kind: PurchaseKind = "regular",
): number => {
    const cents = Math.max(0, Math.round(listPriceCents || 0));
    const half = Math.max(0, doneThisYear || 0) >= REFERRAL_PURCHASE_FULL_PER_YEAR;
    const perUsd = kind === "regular" ? REFERRAL_PURCHASE_POINTS_PER_USD : REFERRAL_REDUCED_POINTS_PER_USD[kind];
    const step = kind === "regular" ? REFERRAL_PURCHASE_ROUND_TO : REDUCED_ROUND_TO;
    // В тысячных долях балла (ставки — с одним знаком после запятой) и ещё ×2 под половину —
    // целое число: ровная половина шага не уезжает из-за float.
    const milli2 = cents * Math.round(perUsd * 10) * (half ? 1 : 2);
    return Math.round(milli2 / (step * 2000)) * step;
};

/** Друг купил диагностику ($300) по ссылке — 3 750 приглашённых (таблица v8.2). PROPOSAL. */
export const REFERRAL_DIAGNOSTIC_POINTS = friendPurchasePoints(30000, 0, "diagnostic");

/** Скидка другу по реферальной ссылке — −10 % (страница «Реферальная программа»). PAID. */
export const FRIEND_DISCOUNT_PERCENT_TODAY = 10;

/**
 * Выгода самого пригласившего — 10 % с покупок друга на баланс, их можно потратить на новые
 * продукты (site_server services_fastapi/referral.py COMMISSION_RATE = 0.10). Это деньги
 * партнёрки, а не баллы: подсказки у приглашения начинаются с неё (владелец 29.09).
 */
export const REFERRAL_BALANCE_PERCENT = 10;

/** Неделя строго по плану: +2 000 тренировок (воркер, так же на доске PTSD_5). PAID. */
export const WEEK_ON_PLAN_POINTS = 2000;

/**
 * Первый план тренировок: +2 000 тренировок один раз (владелец 29.09: «повторное составление
 * плана не добавляет баллов, а первое должно дать 2000»; points_rules.FIRST_PLAN_POINTS).
 * Удалить план и составить заново — баллов не прибавит.
 */
export const FIRST_PLAN_POINTS = 2000;

/** Мини-тест по главе — 150 обучения, один раз (learningPoints.quizPoints). PAID. */
export const MINI_TEST_POINTS = 150;

/**
 * Любой отзыв о продукте — +500 вклада, раз на продукт (points_rules.REVIEW_POINTS,
 * флаг POINTS_V5_REVIEW). PROPOSAL; сегодня отзыв баллов не даёт.
 */
export const REVIEW_POINTS = 500;
export const REVIEW_POINTS_TODAY = 0;

/**
 * Покупка — 1 000 вклада за $1 цены без скидки; в календарном году полная ставка до
 * $300 покупок, дальше 30 %; каждая покупка округляется до 500 (points_rules.PURCHASE_*,
 * флаг POINTS_V5_PURCHASE_BY_PRICE). Пакет — по цене пакета, а его содержимое отдельно не
 * считается; второе издание того же продукта — тоже нет. Курс, выданный админом, — как
 * купленный; возврат снимает баллы покупки. PROPOSAL; сегодня любая покупка курса — +10.
 *
 * Аюрведическое (`kind`, см. PurchaseKind) — своей ставкой и вне порога: диагностика $300 →
 * 3 000, обе → 6 000, консультация $1 550 → 15 500, спрей $25 → 2 500, семена $15 → 1 500.
 *
 * `spentThisYearCents` — сколько человек уже купил в этом году по ценам без скидки.
 * Сайт этого обычно не знает, поэтому чип показывает число для первой покупки года:
 * позже в году оно может быть только меньше.
 */
export const PURCHASE_POINTS_PER_USD = 1000;
export const PURCHASE_REDUCED_POINTS_PER_USD: Record<Exclude<PurchaseKind, "regular">, number> = {
    diagnostic: 10,
    consultation: 10,
    ayurvedic: 100,
};
export const PURCHASE_FULL_RATE_USD_PER_YEAR = 300;
export const PURCHASE_RATE_AFTER = 0.3;
export const PURCHASE_ROUND_TO = 500;
export const PURCHASE_POINTS_TODAY = 10;
export const purchasePoints = (
    listPriceCents: number,
    spentThisYearCents = 0,
    kind: PurchaseKind = "regular",
): number => {
    if (kind !== "regular") {
        const cents = Math.max(0, Math.round(listPriceCents || 0));
        return Math.round((cents * PURCHASE_REDUCED_POINTS_PER_USD[kind]) / (REDUCED_ROUND_TO * 100)) * REDUCED_ROUND_TO;
    }
    const price = Math.max(0, listPriceCents || 0) / 100;
    const spent = Math.max(0, spentThisYearCents || 0) / 100;
    const fullLeft = Math.max(0, PURCHASE_FULL_RATE_USD_PER_YEAR - spent);
    const full = Math.min(price, fullLeft);
    const raw = full * PURCHASE_POINTS_PER_USD + (price - full) * PURCHASE_POINTS_PER_USD * PURCHASE_RATE_AFTER;
    return Math.round(raw / PURCHASE_ROUND_TO) * PURCHASE_ROUND_TO;
};

/**
 * Правка расшифровки после подтверждения ИИ: 50 на иностранном, 10 на русском, не больше
 * 50 000 в год за все правки (добавки v6; points_rules.CORRECTION_*, флаг
 * POINTS_V5_CORRECTIONS_AI). PROPOSAL; сегодня +1 за отправку и +5, когда редактор примет.
 */
export const CORRECTION_POINTS_FOREIGN = 50;
export const CORRECTION_POINTS_RU = 10;
export const CORRECTION_YEARLY_POINTS_CAP = 50000;
export const correctionPoints = (lang: string | undefined | null): number =>
    (lang || "").toLowerCase().startsWith("ru") ? CORRECTION_POINTS_RU : CORRECTION_POINTS_FOREIGN;

/**
 * «Сообщить об ошибке» на странице, в рецепте, в продукте (владелец, 23.10.2026: «нужно начислять баллы как
 * за правку субтитров в лекциях и клипах (как для иностранного языка)»). v8.2 платит, когда администратор
 * принял сообщение, — всегда цену иностранного языка, на любом языке страницы (site_server
 * points_rules.ERROR_REPORT_POINTS = CORRECTION_POINTS_FOREIGN, флаг POINTS_V5_CORRECTIONS_AI). Потолки
 * как у правок, но свои: 20 принятых в сутки, 40 за неделю, 50 000 в год. Сегодня (без v8.2): +1 за
 * отправку и +5, когда примут, — как у правок.
 */
export const ERROR_REPORT_POINTS = CORRECTION_POINTS_FOREIGN;
export const ERROR_REPORT_YEARLY_POINTS_CAP = CORRECTION_YEARLY_POINTS_CAP;

/**
 * СУП: выбранный вопрос или поиск — +50 обучения, не больше 10 000 в год на СУП
 * (таблица v8.2; раньше на доске PTSD_3 было +250). PAID с 03.10 (владелец: «переведи к
 * обычным баллам, которые в описании баллов стоят»): site_server learning_score платит 50
 * (было 250), не больше 10 000 в календарный год. Повод — как в описании (владелец 03.10,
 * «сделать как в описании»): каждый выбранный вопрос или поиск, токен за который списал
 * сервер (POST /api/learning/sup-spend, флаг SUP_SERVER_SPEND в questionsQuotaApi.ts), и
 * свой вопрос, принятый к ответу; один запрос — одно начисление, потолок на оба общий.
 */
export const SUP_QUESTION_POINTS = 50;
export const SUP_QUESTION_POINTS_TODAY = SUP_QUESTION_POINTS;

/**
 * Следующая часть курса −20 % владельцу предыдущей (points_rules.PREVIOUS_PART,
 * NEXT_PART_DISCOUNT_PERCENT, флаг POINTS_V5_NEXT_PART_DISCOUNT). Цену спрашиваем у
 * сервера (GET /api/payment/courses/next-part-price) — только для этих курсов.
 */
export const NEXT_PART_DISCOUNT_PERCENT = 20;
export const NEXT_PART_PREVIOUS: Record<string, string> = {
    "effective-health-part-2": "effective-health",
    "happy-family-part-2": "happy-family",
    "happy-family-part-3": "happy-family-part-2",
    "happy-family-part-4": "happy-family-part-3",
    "happy-family-part-5": "happy-family-part-4",
};

/**
 * Остальная таблица v8.2 (PROPOSAL, где не сказано иначе) — для подсказок лиги и чипов.
 * Потолки — в год, если не сказано иначе. Имя POINTS_V4 осталось с первой таблицы, числа — v8.2.
 */
export const POINTS_V4 = {
    referral: {
        purchasePerUsd: REFERRAL_PURCHASE_POINTS_PER_USD,
        diagnostic: REFERRAL_DIAGNOSTIC_POINTS,
        ayurvedicPerUsd: REFERRAL_REDUCED_POINTS_PER_USD.ayurvedic,
        install: 2000,
        firstMeeting: 2000,
        friendStarted: 3000,
    },
    meeting: { seva: 2000, health: 1600, spirit: 1400, edu: 1200, club: 1000, online: 1000, perParticipant: 100, weeklyCap: 3000 },
    club: { goodDeed: 100, addFriend: 100, joinClub: 1000, firstMessage: 100 },
    /** planCreate — только ПЕРВЫЙ план (FIRST_PLAN_POINTS), повторный не даёт ничего. */
    workouts: { weekOnPlan: WEEK_ON_PLAN_POINTS, newbieBonus: 600, planCreate: FIRST_PLAN_POINTS, testWorkout: 1000 },
    learning: {
        lessonMinute: 50,
        miniTest: MINI_TEST_POINTS,
        lessonQuestion: 50,
        appLearning: 500,
        sup: SUP_QUESTION_POINTS,
        /** Минута лекции или клипа — одно и то же (одна ставка и один потолок на обе). */
        freeMinute: 3,
        specialistTicket: 150,
        specialistMessage: 10,
    },
} as const;

/**
 * Строка таблицы для встречи — по ПРЕФИКСУ типа (до «_»), а не по направлению: в направлении
 * «Деятельность клуба» лежат и служение (seva_*), и обучение (edu_*), и встреча клуба
 * (social_club_meeting). Онлайн — всегда «online». Неизвестное — «club». Зеркало сервера
 * (site_server services_fastapi/points_rules.py MEETING_KIND_BY_PREFIX, meeting_kind).
 */
export type MeetingKind = "seva" | "health" | "spirit" | "edu" | "club" | "online";
export const MEETING_KIND_BY_PREFIX: Record<string, Exclude<MeetingKind, "online">> = {
    seva: "seva",
    health: "health",
    spirit: "spirit",
    edu: "edu",
    culture: "edu",
    social: "club",
    club: "club",
    other: "club",
};
export const meetingKind = (typeId: string | null | undefined, mode?: string | null): MeetingKind => {
    if ((mode || "").trim().toLowerCase() === "online") return "online";
    const t = String(typeId || "").trim();
    const prefix = t.includes("_") ? t.split("_")[0] : t;
    return MEETING_KIND_BY_PREFIX[prefix] ?? "club";
};
/** Сколько встреча даёт пришедшему (с принятым фото): «Встреча здоровья · +1 600». */
export const meetingPoints = (typeId: string | null | undefined, mode?: string | null): number =>
    POINTS_V4.meeting[meetingKind(typeId, mode)];

/**
 * Шкалы сфер v8.2 — при каком счёте шар полон. Только шкала: баллов не меняет. Пока правила
 * v8.2 за выключенными флагами, шары рисуются по сегодняшним шкалам (shared/api/otherScores.ts,
 * FULL_AT), а эти числа — для подсказок и для дня, когда флаги включат.
 */
export const SPHERE_SCALE_V82 = {
    contrib: 300000,
    referrals: 300000,
    social: 120000,
    workouts: 100000,
    learning: 90000,
} as const;

/**
 * Пределы таблицы v8.2 (колонка «предел») — для «Подробнее» экрана «Как получить баллы».
 * Считает их сервер (points_rules.py); здесь только то, что пишем человеку. Меняется
 * таблица — меняется здесь. Годовые, где не сказано иначе.
 */
export const POINTS_LIMITS_V82 = {
    referral: { installPerYear: 10, firstMeetingPerYear: 5, friendStartedPerYear: 10 },
    club: { goodDeedPerDay: 1, goodDeedPerYear: 100, addFriendPerYear: 50, firstMessagePerYear: 20 },
    /** Первый план — один раз за всё время; тестовая тренировка — до 6 в год. */
    workouts: { planCreateOnce: true, testWorkoutPerYear: 6 },
    /** СУП — на весь СУП; бесплатное — лекции и клипы вместе; приложение — за всё время. */
    learning: { supPerYear: 10000, freePerYear: 20000, appLearningTotal: 10000 },
} as const;
